<template>
  <div no-gutters>
    <v-text-field readonly :label="label" :value="text" hide-details>
      <template v-slot:append-outer>
        <BtnCopiableIcon
          :copiable="text || ''"
          :label="label"
          :disabled="!text"
          class="mb-1"
          color="grey darken-2"
        />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import BtnCopiableIcon from '@/components/BtnCopiableIcon'
export default {
  name: 'TextCopiable',
  components: { BtnCopiableIcon },
  props: {
    text: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
